import { render, staticRenderFns } from "./PropertiesListItem.vue?vue&type=template&id=53d64d08&scoped=true&"
import script from "./PropertiesListItem.vue?vue&type=script&lang=js&"
export * from "./PropertiesListItem.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesListItem.vue?vue&type=style&index=0&id=53d64d08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d64d08",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
